import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert, Modal, ModalBody } from "reactstrap";
import { getOwnersByValuation } from "../../../../services/ValitanApiService";

const OwnersTab = ({ valuationId }) => {
    const [owners, setOwners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [previewImage, setPreviewImage] = useState(null);

    useEffect(() => {
        if (!valuationId) return;

        const fetchOwners = async () => {
            try {
                setLoading(true);
                const response = await getOwnersByValuation(valuationId);

                if (response.status === 200 && response.data?.data) {
                    setOwners(response.data.data);
                } else {
                    setOwners([]);
                }
            } catch (error) {
                console.error("Failed to fetch owners:", error);
                setOwners([]);
            } finally {
                setLoading(false);
            }
        };

        fetchOwners();
    }, [valuationId]);

    if (loading) {
        return (
            <div className="text-center my-3">
                <Spinner color="primary" />
            </div>
        );
    }

    if (!owners.length) {
        return <Alert color="info">No owners available</Alert>;
    }

    return (
        <div>
            <h5 className="mb-3 text-primary">Owners</h5>
            <Table bordered hover responsive>
                <thead className="table-light">
                    <tr>
                        <th>#</th>
                        <th>Photo</th>
                        <th>Full Name</th>
                        <th>Phone Number</th>
                        <th>ID Type</th>
                        <th>ID Number</th>
                    </tr>
                </thead>
                <tbody>
                    {owners.map((owner, index) => (
                        <tr key={owner.id}>
                            <td>{index + 1}</td>
                            <td>
                                {owner.photo_url ? (
                                    <img
                                        src={owner.photo_url}
                                        alt={`${owner.first_name} ${owner.last_name}`}
                                        className="avatar-md rounded"
                                        style={{
                                            objectFit: "cover",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => setPreviewImage(owner.photo_url)}
                                    />
                                ) : (
                                    <div
                                        className="avatar-md rounded bg-light d-flex align-items-center justify-content-center"
                                    >
                                        <i
                                            className="ri-user-line"
                                            style={{ fontSize: "24px", color: "#6c757d" }}
                                        ></i>
                                    </div>
                                )}
                            </td>
                            <td>
                                {owner.first_name}{" "}
                                {owner.middle_name ? owner.middle_name + " " : ""}
                                {owner.last_name}
                            </td>
                            <td>{owner.phone_number || "-"}</td>
                            <td>{owner.identity_type_id || "-"}</td>
                            <td>{owner.id_number || "-"}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Preview Modal */}
            <Modal isOpen={!!previewImage} toggle={() => setPreviewImage(null)} centered size="lg">
                <ModalBody className="text-center">
                    {previewImage && (
                        <img
                            src={previewImage}
                            alt="Preview"
                            style={{
                                maxWidth: "100%",
                                maxHeight: "80vh",
                                borderRadius: "10px",
                                objectFit: "contain",
                            }}
                        />
                    )}
                </ModalBody>
            </Modal>
        </div>
    );
};

export default OwnersTab;
